import { gql } from "apollo-angular";

export const APPLY_COUPON_CODE = gql`
    mutation ApplyCouponCode($couponCode: String!,) {
        applyCouponCode(couponCode: $couponCode) {
            ... on Order {
                id
                total
                totalWithTax
                discounts {
                    adjustmentSource
                    type
                    description
                    amount
                    amountWithTax
                }
                couponCodes
              }
              ... on CouponCodeInvalidError {
                errorCode
                message
                couponCode
              }
              ... on CouponCodeExpiredError {
                errorCode
                message
                couponCode
              }
              ... on CouponCodeLimitError {
                errorCode
                message
                couponCode
                limit
              }
        }
    }
`;
